import React, { useMemo, useState, useCallback, useEffect } from 'react';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import styles from '../stocktabpanel.module.scss';
import ShipmentRecycling from '../../../components/Shipment/_recycling';
import IncomingRecycling from '../../../components/Incoming/_recycling';
import Reports from '../../../components/Reports';
// import StockMetric from '../../../components/StockMetric';
import QRCodeTab from '../../../components/QRCodeTab';
import ResponsiblePerson from '../../../components/ResponsiblePerson';
import PopupActMVP from '../../../components/PopupActMVP';
import RecyclingOrders from '../../../components/RecyclingOrders';
import WasteBalancing from '../../../components/WasteBalancing';
import Production from '../../../components/Production';
import TaskTab from '../../../components/TaskTab';
import EditAct from '../../../components/EditAct';
import SalesOrders from '../../../components/SalesOrders';
import MessagesAdmin from '../../../components/AdminTabList/MessagesAdmin';

const StockTabPanelRecycling = ({
  plantId,
  isUseM4,
  isUseM15B,
  isAutoAcceptIncoming,
  showTranspOrder,
  isUseAZH,
  isUseCheckShiptoAddress,
  isUseBuyoutWithTtn,
  isRecyclingOrdersEnabled,
  isReadyStock,
  isSemiStock,
  tabsListState,
  useFactWeight,
  useProductionLg
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const savedTabSelect = Number(localStorage.getItem('tabSelect'));

  useEffect(() => {
    if ((savedTabSelect || savedTabSelect === 0)
    && tabsListState.map((item) => item.id).includes(savedTabSelect)) {
      setSelectedIndex(savedTabSelect);
    }
  }, [savedTabSelect, tabsListState]);

  const shipmentRecycling = useMemo(() => () => (
    <>
      <ShipmentRecycling isUseM4={isUseM4}
                         isUseM15B={isUseM15B}
                         plantId={plantId}
                         isRecyclingOrdersEnabled={isRecyclingOrdersEnabled}
                         showTranspOrder={showTranspOrder}
                         isUseCheckShiptoAddress={isUseCheckShiptoAddress}
                         isUseBuyoutWithTtn={isUseBuyoutWithTtn}
                         isReadyStock={isReadyStock}
      />
    </>
  ), [
    plantId,
    isUseM4,
    isUseM15B,
    showTranspOrder,
    isUseCheckShiptoAddress,
    isUseBuyoutWithTtn,
    isRecyclingOrdersEnabled,
    isReadyStock
  ]);

  const incomingRecycling = useMemo(() => () => (
    <>
      <IncomingRecycling isUseM4={isUseM4}
                         plantId={plantId}
                         showTranspOrder={showTranspOrder}
      />
    </>
  ), [plantId, isUseM4, showTranspOrder]);

  const reports = useMemo(() => () => (
    <Reports plantId={plantId} typeStock={2} />
  ), [plantId]);

  // const stockMetric = useMemo(() => () => (
  //   <StockMetric plantId={plantId} typeStock={2} />
  // ), [plantId]);

  const qrCodeTab = useMemo(() => () => (
    <>
      <QRCodeTab isUseM4={isUseM4}
                 shippingType={2}
                 plantId={plantId}
                 showTranspOrder={showTranspOrder}
      />
    </>
  ), [plantId, isUseM4, showTranspOrder]);

  const responsiblePerson = useMemo(() => () => (
    <ResponsiblePerson plantId={plantId} shippingType={2} />
  ), [plantId]);

  const recyclingOrders = useMemo(() => () => (
    <RecyclingOrders plantId={plantId}
                     shippingType={2}
                     useProductionLg={useProductionLg}
                     isSemiStock={isSemiStock}
    />
  ), [isSemiStock, plantId, useProductionLg]);

  const production = useMemo(() => () => (
    <Production plantId={plantId}
                shippingType={2}
                useFactWeight={useFactWeight}
    />
  ), [plantId, useFactWeight]);

  const wasteBalancing = useMemo(() => () => (
    <WasteBalancing plantId={plantId} />
  ), [plantId]);

  const taskTab = useMemo(() => () => (
    <TaskTab plantId={plantId} />
  ), [plantId]);

  const editAct = useMemo(() => () => (
    <EditAct plantId={plantId} shippingType={2} />
  ), [plantId]);

  const orders = useMemo(() => () => (
    <SalesOrders plantId={plantId} />
  ), [plantId]);

  const messagesAdmin = useMemo(() => () => (
    <>
      <MessagesAdmin plantId={plantId} />
    </>
  ), [plantId]);

  const onSelectionChanged = useCallback(({ name, value }) => {
    if (name === 'selectedIndex') {
      setSelectedIndex(value);
    }
  }, []);

  return (
    <>
      <PopupActMVP isUseM4={isUseM4} isUseAZH={isUseAZH} />
      <TabPanel selectedIndex={selectedIndex}
                onOptionChanged={onSelectionChanged}
                elementAttr={{ class: styles.tabs }}
                deferRendering
                repaintChangesOnly
      >
        <Item render={shipmentRecycling} />
        <Item render={incomingRecycling} disabled={isAutoAcceptIncoming ? 'true' : ''} />
        <Item render={reports} />
        {/* <Item render={stockMetric} /> */}
        <Item />
        <Item render={qrCodeTab} />
        {/* временно отключили по просьбе Саблиной Алевтины,
        после релиза 6.7 решили включить всем */}
        <Item render={responsiblePerson} />
        <Item render={editAct} />
        <Item render={recyclingOrders} />
        <Item render={production} />
        <Item render={wasteBalancing} />
        <Item render={taskTab} />
        <Item render={orders} />
        <Item />
        <Item render={messagesAdmin} />
      </TabPanel>
    </>

  );
};

export default StockTabPanelRecycling;
